// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { RENDER_DOCUMENT_OPTIONS } from '../../helpers/contentful';

const Wysiwyg = (props) => (
  <div className="Wysiwyg">
    <div className="Wysiwyg-inner">
      <div className="Wysiwyg-text">
        {props.sectionTitle && <h2>{props.sectionTitle}</h2>}
        {documentToReactComponents(props.document, RENDER_DOCUMENT_OPTIONS)}
      </div>
    </div>
  </div>
);

export default Wysiwyg;
